/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */
   
import React from "react";
import { AuthPieceProps } from "aws-amplify-react/props";
import styles from "./LoadIndicator.module.css";

const LoadIndicator: React.FC<AuthPieceProps> = ({ authState }) => {
  if (authState === "loading") {
    return (
      <div className={styles.indicatorContainer}>
        <div className={styles.indicator}>
          <img src="./loading.svg" alt="loading..." />
        </div>
      </div>
    );
  }

  return null;
};

export default LoadIndicator;
